module.exports = __webpack_public_path__ + "static/img/XWZX-35.dfafd14.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/base/XWZX-35.jpg
// module id = l5ZH
// module chunks = 1